import { Box } from "@mui/system";
import React from "react";

const GoalDetailsSettingsInactiveText = ({children}: {children: React.ReactNode}) => <Box sx={{
    opacity: 0.5
}}>{children}</Box>
export default GoalDetailsSettingsInactiveText;